import {Link} from 'react-router'
import {useState, useEffect} from 'react'
import './Manager.css'
import './Specials.css'
import './SpecialsMenuUpdate.css'
import ManagerNavbar from './components/ManagerNavbar.jsx'
import { FaCaretUp } from "react-icons/fa";
import { MdDoNotDisturbAlt } from "react-icons/md";

export default function RestaurantWeeksFallUpdate(){

    const [prixFixe, setPrixFixe] = useState(false)
    const [updatingMenu, setUpdatingMenu] = useState(false)
    const [updatingImage, setUpdatingImage] = useState(false)
    const [updatingImage2, setUpdatingImage2] = useState(false)
    const [updatingLogoImage, setUpdatingLogoImage] = useState(false)
    const [allAnnualEventsMenuItems, setAllAnnualEventsMenuItems] = useState([])
    const [annualEventPrice, setAnnualEventPrice] = useState(0)
    // const [winePairingPrice, setWinePairingPrice] = useState(0)
    const [eventDates, setEventDates] = useState('')
    const [editMode, setEditMode] = useState(false)
    const [displaySection, setDisplaySection] = useState('prix fixe - appetizers')
    const [currentImage, setCurrentImage] = useState('')
    const [cloudinaryPublicID, setCloudinaryPublicID] = useState('')
    const [cloudinarySecureURL, setCloudinarySecureURL] = useState('')
    const [isChecked, setIsChecked] = useState(false)
    const [isNoWebsiteImageChecked, setIsNoWebsiteImageChecked] = useState(false)
    const [isNoLogoImageChecked, setIsNoLogoImageChecked] = useState(false)
    const [websiteImageURL, setWebsiteImageURL] = useState('')
    const [logoImageURL, setLogoImageURL] = useState('')
    const [websiteImageID, setWebsiteImageID] = useState('')
    const [logoImageID, setLogoImageID] = useState('')
    const [section, setSection] = useState('')

    useEffect(()=>getAnnualEventsMenuItems(),[])
    useEffect(()=>getAnnualEventPrice(),[])
    // useEffect(()=>getWinePairingPrice(),[])
    useEffect(()=>getEventDates(),[])
    useEffect(()=>getWebsiteImage(),[])
    useEffect(()=>getLogoImage(),[])

    const BASE_URL = (process.env.NODE_ENV == 'production') ?
                    'https://olea-iwpz.onrender.com' : 
                    'http://localhost:1436'

    const event = "Restaurant Weeks: Fall"
    const event_url = 'restaurant-weeks-fall'
    const event_obj = 'RestaurantWeekFall'

    function getWebsiteImage(){
        fetch(`${BASE_URL}/api/events/website-image/${event_url}`)
            .then(res=>res.json())
            .then(data=>{
                setWebsiteImageURL(data.cloudinary_secure_URL)
                setWebsiteImageID(data.cloudinaryPublicID)
            })
            .catch(err=>console.log(err))
    }

    function getLogoImage(){
        fetch(`${BASE_URL}/api/events/website-image/restaurant-week-fall-logo-image`)
            .then(res=>res.json())
            .then(data=>{
                setLogoImageURL(data.cloudinary_secure_URL)
                setLogoImageID(data.cloudinaryPublicID)
            })
            .catch(err=>console.log(err))
    }

    async function createItem(formData){
        setUpdatingMenu(true)
        setTimeout(postItem,0)
        async function postItem(){
            await fetch(`${BASE_URL}/api/annual-events-menu-items`,{method:'POST',
                                                        headers:{'Content-Type':'application/json'},
                                                        body: JSON.stringify({
                                                            event: formData.get('event'),
                                                            section: formData.get('section'),
                                                            name: formData.get('name'),
                                                            price: formData.get('price'),
                                                            allergiesAbbreviated: formData.get('allergies-abbreviated'),
                                                            allergiesComplete: formData.get('allergies-complete'),
                                                            description: formData.get('description'),
                                                            postDescription: formData.get('post-description'),
                                                            descriptionIntro: formData.get('description-intro'),
                                                            // wineGrapes: formData.get('wine-grapes'),
                                                            // wineName: formData.get('wine-name'),
                                                            // wineVintage: formData.get('wine-vintage'),
                                                            // wineDescription: formData.get('wine-description'),
                                                            previewSource
                                                        })
            })
            .then(setUpdatingMenu(true))
            .then(()=>alert(`
                ${event}
                New Menu Item Created:
                - ${formData.get('name')}`))
            .then(()=>getAnnualEventsMenuItems())
            .then(()=>setUpdatingMenu(false))
            .then(()=>setSection(''))
            .catch(err=>console.log(err))
        }
    }

    async function updateItem(formData){
        setUpdatingMenu(true)
        setTimeout(putItem,0)
        async function putItem(){
            await fetch(`${BASE_URL}/api/annual-events-menu-items/${formData.get('id')}`,{ method:'PUT',
                                                                                    headers:{'Content-Type':'application/json'},
                                                                                    body: JSON.stringify({
                                                                                      
                                                                                        name: formData.get('name'),
                                                                                        allergiesAbbreviated: formData.get('allergies-abbreviated'),
                                                                                        allergiesComplete: formData.get('allergies-complete'),
                                                                                        descriptionIntro: formData.get('description-intro'),
                                                                                        description: formData.get('description'),
                                                                                        postDescription: formData.get('post-description'),
                                                                                        price: formData.get('price'),
                                                                                        // wineGrapes: formData.get('wine-grapes'),
                                                                                        // wineName: formData.get('wine-name'),
                                                                                        // wineVintage: formData.get('wine-vintage'),
                                                                                        // wineDescription: formData.get('wine-description'),
                                                                                        cloudinary_public_ID: formData.get('cloudinary_public_ID'),
                                                                                        cloudinary_secure_URL: formData.get('cloudinary_secure_URL'),
                                                                                        previewSource,
                                                                                        isChecked
                                                                                    })
            })
            .then(()=>alert(`
                Menu Item Updated:
                - ${formData.get('name')}`))
            .then(()=>setEditMode(false))
            .then(document.querySelector('#section-wrapper').style.display = 'none')
            .then(()=>getAnnualEventsMenuItems())
            .then(()=>setUpdatingMenu(false))
            .then(()=>setSection(''))         
            // .then(()=>clearForm())   
            .catch(err=>console.log(err))
        }
    }


    function getAnnualEventsMenuItems(){
        try{
            fetch(`${BASE_URL}/api/annual-events-menu-items`)
                .then(res=>res.json())
                .then(json=>setAllAnnualEventsMenuItems(json))
                .then(clearForm())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function getAnnualEventPrice(){
        try{
            fetch(`${BASE_URL}/api/annual-event-prices`)
                .then(res=>res.json())
                .then(json=>setAnnualEventPrice(json[0][event_obj]))
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    // function getWinePairingPrice(){
    //     try{
    //         fetch(`${BASE_URL}/api/annual-event-prices`)
    //             .then(res=>res.json())
    //             .then(json=>setWinePairingPrice(json[0].RestaurantWeekFallWinePairing))
    //             .catch(err=>console.log(err))
    //     }catch(err){
    //         console.log(err)
    //     }
    // }

    function getEventDates(){
        try{
            fetch(`${BASE_URL}/api/annual-event-prices`)
                .then(res=>res.json())
                .then(json=>setEventDates(json[0].RestaurantWeekFallDates))
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function deleteAnnualEventsMenuItem(id){
        try{
            fetch(`${BASE_URL}/api/annual-events-menu-items/${id}`,{method:'DELETE'})
                .then(res=>res.json())
                .then(data=>alert(data))
                .then(()=>getAnnualEventsMenuItems())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function archiveItem(id){
        try{
            fetch(`${BASE_URL}/api/annual-events-menu-items/archive/${id}`,{method:'PUT'})
                .then(res=>res.json())
                .then(data=>alert(data))
                .then(()=>getAnnualEventsMenuItems())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function unarchiveItem(id){
        try{
            fetch(`${BASE_URL}/api/annual-events-menu-items/unarchive/${id}`,{method:'PUT'})
                .then(res=>res.json())
                .then(data=>alert(data))
                .then(()=>getAnnualEventsMenuItems())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function populateForm(id,
                          section,
                          name,
                          allergiesAbbreviated,
                          allergiesComplete,
                          descriptionIntro,
                          description,
                          postDescription,
                          price,
                        //   wineGrapes,
                        //   wineName,
                        //   wineVintage,
                        //   wineDescription,
                          cloudinary_public_ID,
                          cloudinary_secure_URL){
        try{
            setEditMode(true)
            setSection(section)
            setIsChecked(false)
            setCurrentImage(cloudinary_secure_URL ? cloudinary_secure_URL : '')
            setCloudinaryPublicID(cloudinary_public_ID ? cloudinary_public_ID : '')
            setCloudinarySecureURL(cloudinary_secure_URL ? cloudinary_secure_URL : '')
            document.querySelector('.specials-form').scrollIntoView({behavior:'smooth'})

            document.querySelector('#item-id').value = id
            document.querySelector('#section').innerHTML = section
            document.querySelector('#section-wrapper').style.display = 'block'
            document.querySelector('#name').value = name
            document.querySelector('#allergies-abbreviated').value = allergiesAbbreviated
            document.querySelector('#allergies-complete').value = allergiesComplete
            if(section.startsWith('à la carte')) setTimeout(()=>document.querySelector('#description-intro').value = descriptionIntro,100) 
            document.querySelector('#description').value = description
            document.querySelector('#post-description').value = postDescription
            if(section.startsWith('à la carte')) setTimeout(()=>document.querySelector('#price').value = price,100) 
            // if(section.startsWith('prix fixe')) setTimeout(()=>document.querySelector('#wine-grapes').value = wineGrapes,100) 
            // if(section.startsWith('prix fixe')) setTimeout(()=>document.querySelector('#wine-name').value = wineName,100) 
            // if(section.startsWith('prix fixe')) setTimeout(()=>document.querySelector('#wine-vintage').value = wineVintage,100) 
            // if(section.startsWith('prix fixe')) setTimeout(()=>document.querySelector('#wine-description').value = wineDescription,100) 
        }catch(err){
            console.log(err)
        }
    }

    function moveUp(id){
        try{
            fetch(`${BASE_URL}/api/annual-events-menu-items/move-up/${id}`,{method:'PUT'})
                .then(()=>getAnnualEventsMenuItems())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function moveDown(id){
        try{
            fetch(`${BASE_URL}/api/annual-events-menu-items/move-down/${id}`,{method:'PUT'})
                .then(()=>getAnnualEventsMenuItems())
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function clearForm(){
        try{
            // alert('clearForm()')
            document.querySelector('#item-id').value = ''
            document.querySelector('#section').innerHTML = ''
            document.querySelector('#section-wrapper').style.display = 'none'
            document.querySelector('#name').value = ''
            document.querySelector('#allergies-abbreviated').value = ''
            document.querySelector('#allergies-complete').value = ''
            if(document.querySelector('#description-intro')) document.querySelector('#description-intro').value = ''
            document.querySelector('#description').value = ''
            document.querySelector('#post-description').value = ''
            if(document.querySelector('#price')) document.querySelector('#price').value = ''
            // if(document.querySelector('#wine-grapes')) document.querySelector('#wine-grapes').value = ''
            // if(document.querySelector('#wine-name')) document.querySelector('#wine-name').value = ''
            // if(document.querySelector('#wine-vintage')) document.querySelector('#wine-vintage').value = ''
            // if(document.querySelector('#wine-description')) document.querySelector('#wine-description').value = ''
            document.querySelector('#image-file').value = ''
            
            // document.querySelector('#current-image').src = ''
            // document.querySelector('#preview-source').src = ''
            console.log(document.querySelector('#preview-source'))
            document.querySelector('#new-image-dropdown').style.visibility = 'visible'

            setEditMode(false)
            setSection('')
            setIsChecked(false)
            setCurrentImage('')
            setCloudinaryPublicID('')
            setCloudinarySecureURL('')
            setPreviewSource('')
        }catch(err){
            console.log(err)
        }
    }

    function handleChangeDisplaySection(e){
        setDisplaySection(e.target.value)
    }

    function updateEventDates(formData){
        fetch(`${BASE_URL}/api/annual-events-prices`,{method:'PUT',
                                                            headers:{'Content-Type':'application/json'},
                                                            body: JSON.stringify({
                                                                annualEventName:formData.get('annual-event-name'),
                                                                annualEventPrice:formData.get('annual-event-dates'),
                                                            })
        })
        .then(res=>res.json())
        .then(json=>setEventDates(json[0].RestaurantWeekFallDates))
        .catch(err=>console.log(err))
    }

    function updateAnnualEventPrice(formData){
        fetch(`${BASE_URL}/api/annual-events-prices`,{method:'PUT',
                                                            headers:{'Content-Type':'application/json'},
                                                            body: JSON.stringify({
                                                                annualEventName:formData.get('annual-event-name'),
                                                                annualEventPrice:formData.get('annual-event-price'),
                                                            })
        })
        .then(res=>res.json())
        .then(json=>setAnnualEventPrice(json[0][event_obj]))
        .catch(err=>console.log(err))
    }

    // function updateWinePairingPrice(formData){
    //     fetch(`${BASE_URL}/api/annual-events-prices`,{method:'PUT',
    //                                                         headers:{'Content-Type':'application/json'},
    //                                                         body: JSON.stringify({
    //                                                             annualEventName:formData.get('annual-event-name'),
    //                                                             annualEventPrice:formData.get('annual-event-price'),
    //                                                         })
    //     })
    //     .then(res=>res.json())
    //     .then(json=>setWinePairingPrice(json[0].RestaurantWeekFallWinePairing))
    //     .catch(err=>console.log(err))
    // }

    const [previewSource, setPreviewSource] = useState()
    function handleFileInputChange(e){
        const file = e.target.files[0]
        if(file.size > 4500000){
            document.querySelector('#image-file').value = ''
            alert(`
Image file is too large.
Resize to smaller dimensions and try again.

Maximum Recommended Dimensions:
  1000x1000 pixels
`)
            return
        }                
        previewFile(file)
    }
    function previewFile(file){
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = ()=>{
            setPreviewSource(reader.result)
        }
    }
    function handleToggleChange(){
        !isChecked && setPreviewSource('')
        if(!isChecked){
            document.querySelector('#image-file').value = ''
            document.querySelector('#new-image-dropdown').style.visibility = 'hidden'
        }else{
            document.querySelector('#new-image-dropdown').style.visibility = 'visible'
        }
        setIsChecked(!isChecked)
        document.querySelector('#do-not-circle').style.color = isChecked ? 'transparent' : 'red'
    }

    const [previewSource2, setPreviewSource2] = useState()
    function handleWebsiteImageFileInputChange(e){
        // alert(`File Size: ${(e.target.files[0].size * 0.000001).toFixed(1)} Mb`)
        const file = e.target.files[0]
        previewFile2(file)
    }
    function previewFile2(file){
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = ()=>{
            setPreviewSource2(reader.result)
        }
    }

    function handleLogoImageFileInputChange(e){
        // alert(`File Size: ${(e.target.files[0].size * 0.000001).toFixed(1)} Mb`)
        const file = e.target.files[0]
        previewFile3(file)
    }
    function previewFile3(file){
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = ()=>{
            setPreviewSource3(reader.result)
        }
    }





    function updateWebsiteImage(formData){
        if (!previewSource2 && !isNoWebsiteImageChecked) return
        setUpdatingImage(true)
        fetch(`${BASE_URL}/api/events/website-image/${event_url}`,{  method:'PUT',
                                                        headers:{'Content-Type':'application/json'},
                                                        body: JSON.stringify({
                                                            event:formData.get('annual-event-name'),
                                                            cloudinary_public_ID:formData.get('cloudinary_public_ID'),
                                                            cloudinary_secure_URL:formData.get('cloudinary_secure_URL'),
                                                            previewSource2
                                                        })
        }) 
        .then(res=>res.json())
        .then(()=>{
            document.querySelector('#do-not-circle2').style.color = 'transparent'
            setIsNoWebsiteImageChecked(false)
            document.querySelector('#file-input-website-image').style.visibility = 'visible'
        })
        .then(()=>getWebsiteImage())
        .then(()=>setPreviewSource2(''))
        .then(()=>setUpdatingImage(false))
        .catch(err=>console.log(err))        
    }

    const [previewSource3, setPreviewSource3] = useState()    
    function updateLogoImage(formData){
        console.log('updateLogoImage()')
        if (!previewSource3 && !isNoLogoImageChecked) return
        setUpdatingLogoImage(true)
        fetch(`${BASE_URL}/api/events/logo-image/restaurant-week-fall-logo-image`,{  method:'PUT',
                                                        headers:{'Content-Type':'application/json'},
                                                        body: JSON.stringify({
                                                            event:formData.get('annual-event-name'),
                                                            cloudinary_public_ID:formData.get('cloudinary_public_ID'),
                                                            cloudinary_secure_URL:formData.get('cloudinary_secure_URL'),
                                                            previewSource3
                                                        })
        }) 
        .then(res=>res.json())
        .then(()=>{
            document.querySelector('#do-not-circle3').style.color = 'transparent'
            setIsNoLogoImageChecked(false)
            document.querySelector('#file-input-logo-image').style.visibility = 'visible'
        })
        .then(()=>getLogoImage())
        .then(()=>setPreviewSource3(''))
        .then(()=>setUpdatingLogoImage(false))
        .catch(err=>console.log(err))        
    }

    function toggleNoWebsiteImage(){
        !isNoWebsiteImageChecked && setPreviewSource2('')
        if(!isNoWebsiteImageChecked){
            document.querySelector('#website-image-file').value = ''
            document.querySelector('#file-input-website-image').style.visibility = 'hidden'
        }else{
            document.querySelector('#file-input-website-image').style.visibility = 'visible'
        }
        setIsNoWebsiteImageChecked(!isNoWebsiteImageChecked)
        document.querySelector('#do-not-circle2').style.color = isNoWebsiteImageChecked ? 'transparent' : 'red'
    }    

    function toggleNoLogoImage(){
        !isNoLogoImageChecked && setPreviewSource3('')
        if(!isNoLogoImageChecked){
            document.querySelector('#logo-image-file').value = ''
            document.querySelector('#file-input-logo-image').style.visibility = 'hidden'
        }else{
            document.querySelector('#file-input-logo-image').style.visibility = 'visible'
        }
        setIsNoLogoImageChecked(!isNoLogoImageChecked)
        document.querySelector('#do-not-circle3').style.color = isNoLogoImageChecked ? 'transparent' : 'red'
    }    

    function clearWebsiteImageForm(){
        setPreviewSource2('')
        document.querySelector('#website-image-file').value = ''
        setIsNoWebsiteImageChecked(false)
        document.querySelector('#do-not-circle2').style.color = 'transparent'
        document.querySelector('#file-input-website-image').style.visibility = 'visible'
    }

    function clearLogoImageForm(){
        setPreviewSource3('')
        document.querySelector('#logo-image-file').value = ''
        setIsNoLogoImageChecked(false)
        document.querySelector('#do-not-circle3').style.color = 'transparent'
        document.querySelector('#file-input-logo-image').style.visibility = 'visible'
    }

    function handleSectionChange(e){
      setSection(e.target.value)
    }













    return(
        <>
            <div className='manager-page-wrapper'>
                <ManagerNavbar page='events' />
                    <div style={{textAlign:'center',fontSize:'30px'}}>menu manager</div>
                    <div style={{textAlign:'center',fontSize:'30px'}}>{event.toLowerCase()} &gt; update</div>



                        <div className='specials-update-menu' style={{minHeight:'auto'}}>
                            <div>
                                <div className='specials-h1' style={{fontSize:'18px',marginBottom:'0'}}>{event.toLowerCase()} menu</div>
                            </div>

                            <br/>
                            section &nbsp; 
                                <select name='display-section' value={displaySection} onChange={handleChangeDisplaySection}>
                                                {/* <option disabled value=''>select...</option> */}
                                                <option value='prix fixe - appetizers'>prix fixe - appetizers</option>
                                                <option value='prix fixe - entrées'>prix fixe - entrées</option>
                                                <option value='prix fixe - desserts'>prix fixe - desserts</option>
                                                <option value='à la carte - appetizers'>à la carte - appetizers</option>
                                                <option value='à la carte - entrées'>à la carte - entrées</option>
                                                <option value='à la carte - sides'>à la carte - sides</option>

                                </select>






























































                            {displaySection == 'prix fixe - appetizers' && 
                                <>
                                <br/><br/>
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - appetizers' && item.event == event).length == 1 && 
                                    <div className='specials-h2 specials-update-heading'>prix fixe - appetizer</div>}
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - appetizers' && item.event == event).length > 1 && 
                                    <div className='specials-h2 specials-update-heading'>prix fixe - appetizers</div>}

                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - appetizers' && item.event == event).map(data=>{
                                    return(
                                        <div key={data._id} className='special'>
                                            {data.sequence != '1' && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'10px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveUp(data._id))} />
                                            }
                                            
                                            {/* {data.sequence}<br/> */}
                                            <div>
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                            </div>
                                            {data.descriptionIntro && <span style={{fontStyle:'italic'}}>{data.descriptionIntro};</span>}
                                            <span> {data.description}</span>
                                            {data.postDescription && <div style={{fontStyle:'italic'}}>{data.postDescription}</div>}
                                            <div className='allergies-complete'>{data.allergiesComplete}</div>
                                            {/* <div>
                                              <span style={{fontWeight:'900'}}>wine: </span>
                                              {data.wineGrapes},
                                              <span style={{fontWeight:'900'}}> {data.wineName}</span>, {data.wineVintage}, {data.wineDescription}
                                            </div> */}
                                            {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            
                                            <div style={{marginTop:'5px'}}>
                                                <span   className='btn archive-btn'
                                                        onClick={()=>archiveItem(data._id)}>ARCHIVE</span>
                                                <span   className='btn edit-btn'
                                                        onClick={()=>populateForm(data._id,
                                                                                  data.section,
                                                                                  data.name,
                                                                                  data.allergiesAbbreviated,
                                                                                  data.allergiesComplete,
                                                                                  data.descriptionIntro,
                                                                                  data.description,
                                                                                  data.postDescription,
                                                                                  data.price,
                                                                                //   data.wineGrapes,
                                                                                //   data.wineName,
                                                                                //   data.wineVintage,
                                                                                //   data.wineDescription,
                                                                                  data.cloudinary_public_ID,
                                                                                  data.cloudinary_secure_URL                                                                                
                                                                                )}>EDIT</span>                                                    
                                                <span   className='btn delete-btn'
                                                        onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>

                                            </div>

                                            {data.sequence != allAnnualEventsMenuItems.filter(item=>item.section == 'prix fixe - appetizers' && item.sequence && item.event == event).length && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'0px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    transform:'rotate(180deg',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveDown(data._id))} />
                                            }

                                        </div>
                                    )
                                })}
                                
                                </>
                            }


















































                            {displaySection == 'prix fixe - entrées' && 
                                <>
                                <br/><br/>
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - entrées' && item.event == event).length == 1 && 
                                    <div className='specials-h2 specials-update-heading'>prix fixe - entrée</div>}
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - entrées' && item.event == event).length > 1 && 
                                    <div className='specials-h2 specials-update-heading'>prix fixe - entrées</div>}

                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - entrées' && item.event == event).map(data=>{
                                    return(
                                        <div key={data._id} className='special'>
                                            {data.sequence != '1' && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'10px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveUp(data._id))} />
                                            }
                                            
                                            {/* {data.sequence}<br/> */}
                                            <div>
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                            </div>
                                            {data.descriptionIntro && <span style={{fontStyle:'italic'}}>{data.descriptionIntro};</span>}
                                            <span> {data.description}</span>
                                            {data.postDescription && <div style={{fontStyle:'italic'}}>{data.postDescription}</div>}
                                            <div className='allergies-complete'>{data.allergiesComplete}</div>
                                            {/* <div>
                                              <span style={{fontWeight:'900'}}>wine: </span>
                                              {data.wineGrapes},
                                              <span style={{fontWeight:'900'}}> {data.wineName}</span>, {data.wineVintage}, {data.wineDescription}
                                            </div> */}

                                            {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            
                                            <div style={{marginTop:'5px'}}>
                                                <span   className='btn archive-btn'
                                                        onClick={()=>archiveItem(data._id)}>ARCHIVE</span>
                                                <span   className='btn edit-btn'
                                                        onClick={()=>populateForm(data._id,
                                                                                  data.section,
                                                                                  data.name,
                                                                                  data.allergiesAbbreviated,
                                                                                  data.allergiesComplete,
                                                                                  data.descriptionIntro,
                                                                                  data.description,
                                                                                  data.postDescription,
                                                                                  data.price,
                                                                                //   data.wineGrapes,
                                                                                //   data.wineName,
                                                                                //   data.wineVintage,
                                                                                //   data.wineDescription,
                                                                                  data.cloudinary_public_ID,
                                                                                  data.cloudinary_secure_URL                                                                                                                                                                )}>EDIT</span>                                                    
                                                <span   className='btn delete-btn'
                                                        onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>

                                            </div>

                                            {data.sequence != allAnnualEventsMenuItems.filter(item=>item.section == 'prix fixe - entrées' && item.sequence && item.event == event).length && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'0px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    transform:'rotate(180deg',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveDown(data._id))} />
                                            }

                                        </div>
                                    )
                                })}
                                
                                </>
                            }

















































                            {displaySection == 'prix fixe - desserts' && 
                                <>

                                <br/><br/>
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - desserts' && item.event == event).length == 1 && 
                                    <div className='specials-h2 specials-update-heading'>prix fixe - dessert</div>}
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - desserts' && item.event == event).length > 1 && 
                                    <div className='specials-h2 specials-update-heading'>prix fixe - desserts</div>}

                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'prix fixe - desserts' && item.event == event).map(data=>{
                                    return(
                                        <div key={data._id} className='special'>
                                            {data.sequence != '1' && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'10px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveUp(data._id))} />
                                            }
                                            
                                            {/* {data.sequence}<br/> */}
                                            <div>
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                            </div>
                                            {data.descriptionIntro && <span style={{fontStyle:'italic'}}>{data.descriptionIntro};</span>}
                                            <span> {data.description}</span>
                                            {data.postDescription && <div style={{fontStyle:'italic'}}>{data.postDescription}</div>}
                                            <div className='allergies-complete'>{data.allergiesComplete}</div>
                                            {/* <div>
                                              <span style={{fontWeight:'900'}}>wine: </span>
                                              {data.wineGrapes},
                                              <span style={{fontWeight:'900'}}> {data.wineName}</span>, {data.wineVintage}, {data.wineDescription}
                                            </div> */}

                                            {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            
                                            <div style={{marginTop:'5px'}}>
                                                <span   className='btn archive-btn'
                                                        onClick={()=>archiveItem(data._id)}>ARCHIVE</span>
                                                <span   className='btn edit-btn'
                                                        onClick={()=>populateForm(data._id,
                                                                                  data.section,
                                                                                  data.name,
                                                                                  data.allergiesAbbreviated,
                                                                                  data.allergiesComplete,
                                                                                  data.descriptionIntro,
                                                                                  data.description,
                                                                                  data.postDescription,
                                                                                  data.price,
                                                                                //   data.wineGrapes,
                                                                                //   data.wineName,
                                                                                //   data.wineVintage,
                                                                                //   data.wineDescription,
                                                                                  data.cloudinary_public_ID,
                                                                                  data.cloudinary_secure_URL                                                                                                                                                                )}>EDIT</span>                                                    
                                                <span   className='btn delete-btn'
                                                        onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>

                                            </div>

                                            {data.sequence != allAnnualEventsMenuItems.filter(item=>item.section == 'prix fixe - desserts' && item.sequence && item.event == event).length && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'0px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    transform:'rotate(180deg',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveDown(data._id))} />
                                            }

                                        </div>
                                    )
                                })}
                                
                                </>
                            }
















                            {displaySection == 'à la carte - appetizers' && 
                                <>

                                <br/><br/>
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - appetizers' && item.event == event).length == 1 && 
                                    <div className='specials-h2 specials-update-heading'>à la carte - appetizer</div>}
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - appetizers' && item.event == event).length > 1 && 
                                    <div className='specials-h2 specials-update-heading'>à la carte - appetizers</div>}

                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - appetizers' && item.event == event).map(data=>{
                                    return(
                                        <div key={data._id} className='special'>
                                            {data.sequence != '1' && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'10px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveUp(data._id))} />
                                            }
                                            
                                            {/* {data.sequence}<br/> */}
                                            <div>
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                            </div>
                                            {data.descriptionIntro && <span style={{fontStyle:'italic'}}>{data.descriptionIntro};</span>}
                                            <span> {data.description}</span> <span style={{fontWeight:'900'}}>{data.price}</span>
                                            {data.postDescription && <div style={{fontStyle:'italic'}}>{data.postDescription}</div>}
                                            <div className='allergies-complete'>{data.allergiesComplete}</div>
                                            {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            
                                            <div style={{marginTop:'5px'}}>
                                                <span   className='btn archive-btn'
                                                        onClick={()=>archiveItem(data._id)}>ARCHIVE</span>
                                                <span   className='btn edit-btn'
                                                        onClick={()=>populateForm(data._id,
                                                                                  data.section,
                                                                                  data.name,
                                                                                  data.allergiesAbbreviated,
                                                                                  data.allergiesComplete,
                                                                                  data.descriptionIntro,
                                                                                  data.description,
                                                                                  data.postDescription,
                                                                                  data.price,
                                                                                //   data.wineGrapes,
                                                                                //   data.wineName,
                                                                                //   data.wineVintage,
                                                                                //   data.wineDescription,
                                                                                  data.cloudinary_public_ID,
                                                                                  data.cloudinary_secure_URL                                                                                                                                                                )}>EDIT</span>                                                    
                                                <span   className='btn delete-btn'
                                                        onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>

                                            </div>

                                            {data.sequence != allAnnualEventsMenuItems.filter(item=>item.section == 'à la carte - appetizers' && item.sequence && item.event == event).length && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'0px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    transform:'rotate(180deg',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveDown(data._id))} />
                                            }

                                        </div>
                                    )
                                })}
                                
                                </>
                            }


















                            {displaySection == 'à la carte - entrées' && 
                                <>

                                <br/><br/>
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - entrées' && item.event == event).length == 1 && 
                                    <div className='specials-h2 specials-update-heading'>à la carte - entrée</div>}
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - entrées' && item.event == event).length > 1 && 
                                    <div className='specials-h2 specials-update-heading'>à la carte - entrées</div>}

                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - entrées' && item.event == event).map(data=>{
                                    return(
                                        <div key={data._id} className='special'>
                                            {data.sequence != '1' && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'10px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveUp(data._id))} />
                                            }
                                            
                                            {/* {data.sequence}<br/> */}
                                            <div>
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                            </div>
                                            {data.descriptionIntro && <span style={{fontStyle:'italic'}}>{data.descriptionIntro};</span>}
                                            <span> {data.description}</span> <span style={{fontWeight:'900'}}>{data.price}</span>
                                            {data.postDescription && <div style={{fontStyle:'italic'}}>{data.postDescription}</div>}
                                            <div className='allergies-complete'>{data.allergiesComplete}</div>
                                            {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            
                                            <div style={{marginTop:'5px'}}>
                                                <span   className='btn archive-btn'
                                                        onClick={()=>archiveItem(data._id)}>ARCHIVE</span>
                                                <span   className='btn edit-btn'
                                                        onClick={()=>populateForm(data._id,
                                                                                  data.section,
                                                                                  data.name,
                                                                                  data.allergiesAbbreviated,
                                                                                  data.allergiesComplete,
                                                                                  data.descriptionIntro,
                                                                                  data.description,
                                                                                  data.postDescription,
                                                                                  data.price,
                                                                                //   data.wineGrapes,
                                                                                //   data.wineName,
                                                                                //   data.wineVintage,
                                                                                //   data.wineDescription,
                                                                                  data.cloudinary_public_ID,
                                                                                  data.cloudinary_secure_URL                                                                                                                                                                )}>EDIT</span>                                                    
                                                <span   className='btn delete-btn'
                                                        onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>

                                            </div>

                                            {data.sequence != allAnnualEventsMenuItems.filter(item=>item.section == 'à la carte - entrées' && item.sequence && item.event == event).length && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'0px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    transform:'rotate(180deg',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveDown(data._id))} />
                                            }

                                        </div>
                                    )
                                })}
                                
                                </>
                            }


















                            {displaySection == 'à la carte - sides' && 
                                <>

                                <br/><br/>
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - sides' && item.event == event).length == 1 && 
                                    <div className='specials-h2 specials-update-heading'>à la carte - side</div>}
                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - sides' && item.event == event).length > 1 && 
                                    <div className='specials-h2 specials-update-heading'>à la carte - sides</div>}

                                {allAnnualEventsMenuItems.filter(item=>item.sequence && item.section == 'à la carte - sides' && item.event == event).map(data=>{
                                    return(
                                        <div key={data._id} className='special'>
                                            {data.sequence != '1' && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'10px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveUp(data._id))} />
                                            }
                                            
                                            {/* {data.sequence}<br/> */}
                                            <div>
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                            </div>
                                            {data.descriptionIntro && <span style={{fontStyle:'italic'}}>{data.descriptionIntro};</span>}
                                            <span> {data.description}</span> <span style={{fontWeight:'900'}}>{data.price}</span>
                                            {data.postDescription && <div style={{fontStyle:'italic'}}>{data.postDescription}</div>}
                                            <div className='allergies-complete'>{data.allergiesComplete}</div>
                                            {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            
                                            <div style={{marginTop:'5px'}}>
                                                <span   className='btn archive-btn'
                                                        onClick={()=>archiveItem(data._id)}>ARCHIVE</span>
                                                <span   className='btn edit-btn'
                                                        onClick={()=>populateForm(data._id,
                                                                                  data.section,
                                                                                  data.name,
                                                                                  data.allergiesAbbreviated,
                                                                                  data.allergiesComplete,
                                                                                  data.descriptionIntro,
                                                                                  data.description,
                                                                                  data.postDescription,
                                                                                  data.price,
                                                                                //   data.wineGrapes,
                                                                                //   data.wineName,
                                                                                //   data.wineVintage,
                                                                                //   data.wineDescription,
                                                                                  data.cloudinary_public_ID,
                                                                                  data.cloudinary_secure_URL                                                                                                                                                                )}>EDIT</span>                                                    
                                                <span   className='btn delete-btn'
                                                        onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>

                                            </div>

                                            {data.sequence != allAnnualEventsMenuItems.filter(item=>item.section == 'à la carte - sides' && item.sequence && item.event == event).length && 
                                                <FaCaretUp style={{ margin:'0 auto',
                                                                    fontSize:'60px',
                                                                    position:'relative',
                                                                    top:'0px',
                                                                    color:'grey',
                                                                    cursor:'pointer',
                                                                    transform:'rotate(180deg',
                                                                    width:'100%'}}
                                                            onClick={(()=>moveDown(data._id))} />
                                            }

                                        </div>
                                    )
                                })}
                                
                                </>
                            }





















                        </div>
                      


                    <form   action={editMode ? updateItem : createItem} 
                            id='specials-item-form'
                            className='specials-form'
                            style={{background:`${editMode ? 'lightblue' : 'lightgreen'}`}}>
                        
                        <h2 style={{textAlign:'center'}}>{event.toLowerCase()}</h2>
                        <h2 style={{textAlign:'center'}}>
                            {editMode ? 'update menu item' : 'create new menu item'}

                        </h2>
                        <br/>

                        <input  type='hidden' 
                                name='id' 
                                id='item-id' />

                        <input  type='hidden'
                                name='event' 
                                value={event} />
                        
                       
                            <div    style={{display:'none'}}
                                    id='section-wrapper'>
                                                section: <span id='section'></span>
                                    <br/><br/>
                            </div> 
                        

                        {!editMode &&                         
                                        <label>
                                            section    
                                            &nbsp; 
                                            <select name='section' required value={section} onChange={handleSectionChange} >
                                                <option disabled value=''>select...</option>
                                                <option value='prix fixe - appetizers'>prix fixe - appetizers</option>
                                                <option value='prix fixe - entrées'>prix fixe - entrées</option>
                                                <option value='prix fixe - desserts'>prix fixe - desserts</option>
                                                <option value='à la carte - appetizers'>à la carte - appetizers</option>
                                                <option value='à la carte - entrées'>à la carte - entrées</option>
                                                <option value='à la carte - sides'>à la carte - sides</option>
                                            </select>
                                             <span className='required-field'> *required</span>
                                            <br/><br/>
                                        </label>

                        }             
                        
                        

                        <label>
                            name <span className='required-field'> *required</span><br/>
                            <input  type='text' 
                                    name='name' 
                                    id='name'
                                    maxLength='100'
                                    required
                                    style={{width:'100%'}} />
                        </label>
                        <br/><br/>
                        <label>
                            allergies - abbreviated &nbsp;ex: gl.d.n<br/>
                            <input  type='text' 
                                    name='allergies-abbreviated' 
                                    id='allergies-abbreviated'
                                    maxLength='100'
                                    style={{width:'100%'}} />
                        </label>
                        <br/><br/>
                        <label>
                            allergies - complete &nbsp;ex: gluten, DAIRY, nuts<br/>
                            <input  type='text'
                                    id='allergies-complete'
                                    maxLength='100'
                                    name='allergies-complete' 
                                    style={{width:'100%',color:'red'}} /><br/>
                            UPPER-CASE = CAN NOT BE REMOVED<br/>
                            lower-case = can be omitted
                        </label>
                        <br/><br/>

                        {
                          section.startsWith('à la carte') && 
                                                              <label>
                                                                  description intro<br/>
                                                                  <input  type='text'
                                                                          name='description-intro'
                                                                          maxLength='100'
                                                                          id='description-intro'
                                                                          style={{width:'100%'}} />
                                                              <br/><br/>
                                                              </label>
                        }

                        <label>
                            description<br/>
                            <textarea   rows='5'
                                        maxLength='500'
                                        name='description' 
                                        id='description'
                                        style={{width:'100%'}}></textarea>
                        </label>
                        <br/><br/>

                        <label>
                            extra description<br/>
                            <input  type='text'
                                    id='post-description'
                                    maxLength='100'
                                    placeholder='(please allow 40 minutes cooking time)'
                                    style={{width:'100%'}}
                                    name='post-description' />
                        
                        </label>
                        <br/><br/>

                        {section.startsWith('à la carte') &&
                                                              <label>
                                                                price<br/>
                                                                <input type='text' 
                                                                        id='price'
                                                                        maxLength='100'
                                                                        required
                                                                        autoComplete='off'
                                                                        style={{width:'40%'}}
                                                                        name='price'
                                                                        />
                                                              <br/><br/>
                                                              </label>
                        }

                        {/* {section.startsWith('prix fixe') &&
                         <>
                          <br/><br/>
                          <div style={{textAlign:'center',fontWeight:'900'}}>WINE PAIRING</div><br/>

                          <label>
                            wine varietal(s)
                            
                            <br/>
                            <input type='text' style={{width:'100%'}}  id='wine-grapes' name='wine-grapes' />
                            <br/><br/>
                          </label>

                          <label>
                            wine name
                           
                            <br/>
                            <input type='text' style={{width:'100%'}} requred id='wine-name' name='wine-name' />
                            <br/><br/>
                          </label>

                          <label>
                            wine vintage
                           
                            <br/>
                            <input type='text' style={{width:'30%'}}  id='wine-vintage' name='wine-vintage' />
                            <br/><br/>
                          </label>

                          <label>
                            wine description
                          
                            <br/>
                            <input type='text' style={{width:'100%'}}  id='wine-description' name='wine-description' />
                            <br/><br/>
                          </label>

                         </>
                        
                        } */}
                        
                        {editMode && currentImage && <>current image:<br/></>}

                        {currentImage &&    <>
                                                <div style={{   position:'relative',
                                                                display:'inline-block'}}>
                                                    <div style={{   position:'absolute',
                                                                    width:'100%',
                                                                    height:'100%',
                                                                    display:'grid',
                                                                    placeContent:'center',
                                                                    top:'0',
                                                                    left:'0'}}><MdDoNotDisturbAlt   size='60' 
                                                                                                    id='do-not-circle'
                                                                                                    style={{color:'transparent'}} /></div>
                                                    <img    id='current-image'
                                                            src={currentImage} 
                                                            style={{maxWidth:'100px',maxHeight:'100px'}} />
                                                </div>                    
                                            </>
                        }
                        
                    
                        
                        
                        {editMode && currentImage && <><br/><br/></>}
                        
                        <input  type='hidden' 
                                value={cloudinaryPublicID}
                                id='cloudinary_public_ID'                                                    
                                name='cloudinary_public_ID' />
                        <input  type='hidden'
                                value={cloudinarySecureURL}
                                id='cloudinary_secure_URL'
                                name='cloudinary_secure_URL' />

                        {editMode && currentImage &&    <>                                                        
                                                            <label>
                                                                <input  type='checkbox'
                                                                        checked={isChecked}
                                                                        onChange={handleToggleChange} 
                                                                        name='no-image-checkbox'
                                                                        id='no-image-checkbox'
                                                                />
                                                                &nbsp;display NO image
                                                                <br/><br/>
                                                            </label>
                                                        </>}

                        <label id='new-image-dropdown'>
                            {editMode   ? currentImage ? 'update image (optional)' : 'add image (optional)' 
                                        : 'image file (optional)'}
                            
                            <input  name='image-file' 
                                    id='image-file'
                                    onChange={handleFileInputChange} 
                                    type='file'/>
                            
                        </label>

                        {previewSource && <img src={previewSource} id='preview-source' style={{maxWidth:'300px',maxHeight:'300px'}} />}


                        <br/><br/>
                        <div id='specials-form-buttons' style={{display:'flex',justifyContent:'space-around'}}>
                            {!updatingMenu &&                             
                                <input  type='submit' 
                                        style={{padding:'10px 10px',
                                                cursor:'pointer',
                                                borderRadius:'10px',
                                                border:'2px solid black',
                                                color:'black',
                                                background:'lightgrey',
                                                fontSize:'20px'}}
                                        value = {editMode ? 'update menu item' : 'create new menu item'} />
                            }
                            {updatingMenu &&                             
                                <div style={{   padding:'10px',
                                                borderRadius:'10px',
                                                border:'2px solid black',
                                                color:'#000000',
                                                fontWeight:'900',
                                                background:'darkgrey',
                                                fontSize:'20px',
                                                cursor:'wait'}}>
                                                    <span className='flashing-text'>updating menu</span>
                                </div>
                            }
                            {editMode && !updatingMenu &&                            
                                        <div onClick={clearForm}
                                             style={{   display:'grid',
                                                        placeContent:'center',
                                                        cursor:'pointer',
                                                        borderRadius:'10px',
                                                        border:'2px solid black',
                                                        background:'rgb(255, 89, 118)',
                                                        fontWeight:'900',
                                                        color:'black',
                                                        padding:'10px 10px',
                                                        fontSize:'20px'
                                                    }}>
                                            cancel
                                        </div>
                            }
                        </div>

                    </form>   

            



                    <form   action={updateEventDates} 
                            id='tasting-menu-form'
                            className='specials-form'
                            style={{background:`yellow`}}>
                        <h2 style={{textAlign:'center'}}>
                            {event.toLowerCase()}
                        </h2>
                        <h2 style={{textAlign:'center'}}>
                            dates
                        </h2>
                        <br/><br/>
                        <input  type='hidden'
                                name='annual-event-name'
                                value='RestaurantWeekFallDates'
                        />
                        
                        <div style={{textAlign:'center'}}>
                            {eventDates} 
                            <div>&darr;</div> 
                            <input type='text'
                                    required
                                    min='1'
                                    max='999' 
                                    maxLength='100'
                                    autoComplete='off'
                                    name='annual-event-dates'
                                    style={{width:'26ch',textAlign:'center'}} />
                        </div>
                        <br/><br/>



                        <div style={{display:'flex', justifyContent:'center'}}>
                            <input  type='submit' 
                                    style={{padding:'10px 10px',
                                            cursor:'pointer',
                                            borderRadius:'10px',
                                            border:'2px solid black',
                                            color:'black',
                                            background:'lightgrey',
                                            fontSize:'20px'}}
                                    value = 'update dates' />                        
                        </div>
                        
                    </form>

                    <form   action={updateAnnualEventPrice} 
                            id='tasting-menu-form'
                            className='specials-form'
                            style={{background:`lightblue`}}>
                        <h2 style={{textAlign:'center'}}>
                            {event.toLowerCase()}
                        </h2>
                        <h2 style={{textAlign:'center'}}>
                            prix-fixe dinner price
                        </h2>
                        <br/><br/>
                        <input  type='hidden'
                                name='annual-event-name'
                                value={event_obj}
                        />
                        
                        <div style={{textAlign:'center'}}>
                            ${annualEventPrice}/person &rarr; 
                            $<input type='number'
                                    required
                                    min='1'
                                    max='999' 
                                    maxLength='100'
                                    name='annual-event-price'
                                    style={{width:'6ch'}} />/person
                        </div>
                        <br/><br/>



                        <div style={{display:'flex', justifyContent:'center'}}>
                            <input  type='submit' 
                                    style={{padding:'10px 10px',
                                            cursor:'pointer',
                                            borderRadius:'10px',
                                            border:'2px solid black',
                                            color:'black',
                                            background:'lightgrey',
                                            fontSize:'20px'}}
                                    value = 'update price' />                        
                        </div>
                        
                    </form>











                    {/* <form   action={updateWinePairingPrice} 
                            id='tasting-menu-form'
                            className='specials-form'
                            style={{background:`pink`}}>
                        <h2 style={{textAlign:'center'}}>
                            {event.toLowerCase()}
                        </h2>
                        <h2 style={{textAlign:'center'}}>
                            wine pairing price
                        </h2>
                        <br/><br/>
                        <input  type='hidden'
                                name='annual-event-name'
                                value='RestaurantWeekFallWinePairing'
                        />
                        
                        <div style={{textAlign:'center'}}>
                            ${winePairingPrice}/person &rarr; 
                            $<input type='number'
                                    required
                                    min='1'
                                    max='999' 
                                    maxLength='100'
                                    name='annual-event-price'
                                    style={{width:'6ch'}} />/person
                        </div>
                        <br/><br/>



                        <div style={{display:'flex', justifyContent:'center'}}>
                            <input  type='submit' 
                                    style={{padding:'10px 10px',
                                            cursor:'pointer',
                                            borderRadius:'10px',
                                            border:'2px solid black',
                                            color:'black',
                                            background:'lightgrey',
                                            fontSize:'20px'}}
                                    value = 'update price' />                        
                        </div>
                        
                    </form> */}














                    <form   
                            action={updateWebsiteImage} 
                            id='website-graphic'
                            className='specials-form'
                            style={{background:`orange`}}>

                        <h2 style={{textAlign:'center'}}>
                            {event.toLowerCase()}
                        </h2>
                        <h2 style={{textAlign:'center'}}>
                            website image
                        </h2>
                        
                        <br/><br/>
                        
                        <input  type='hidden'
                                name='annual-event-name'
                                value={event_url}
                        />

                        <input  type='hidden' 
                                name='cloudinary_secure_URL' 
                                value={websiteImageURL}
                                id='cloudinary_secure_URL' />

                        <input  type='hidden' 
                                value={websiteImageID}
                                name='cloudinary_public_ID' 
                                id='cloudinary_public_ID' />
                        
                        <div style={{position:'relative',display:'inline-block'}}>
                            <div style={{
                                            position:'absolute',
                                            width:'100%',
                                            height:'100%',
                                            display:'grid',
                                            placeContent:'center',
                                            top:'0',
                                            left:'0'
                            }}>
                                <MdDoNotDisturbAlt size='150' id='do-not-circle2' style={{color:'transparent'}} />
                            </div>
                            <img src={websiteImageURL ? websiteImageURL : '/no-image.jpg' } style={{maxWidth:'100%'}} />
                        </div>
                        
                        <br/>
                        <div style={{textAlign:'center'}}>current image</div>
                        <br/><br/>
                        
                        <div id='file-input-website-image'>
                            <label>
                                {websiteImageURL ? <div>replace image (optional)</div> : <div>add image (optional)</div>}
                                <input  name='website-image-file' 
                                        id='website-image-file'
                                        onChange={handleWebsiteImageFileInputChange}
                                        type='file' />
                            </label>
                        </div>
                        <br/><br/>
                                                
                        {previewSource2 &&  <>
                                                <img src={previewSource2} style={{maxWidth:'300px',maxHeight:'300px'}} /><br/><br/>
                                            </>}

                        {websiteImageURL &&                         
                                            <>                        
                                                <br/>
                                                <label style={{display:'flex',alignItems:'center'}}>
                                                    <input  type='checkbox' 
                                                            name='no-image'
                                                            checked={isNoWebsiteImageChecked}
                                                            onChange={toggleNoWebsiteImage}
                                                    /> 
                                                    <span>&nbsp;&nbsp;remove image / display NO image</span>
                                                </label>
                                                <br/>
                                            </>
                        }
                        
                        <br/><br/>
                        <div style={{display:'flex',justifyContent:'space-around'}}>
                            {!updatingImage &&                             
                                <input  type='submit' 
                                        style={{padding:'10px 10px',
                                                cursor:'pointer',
                                                borderRadius:'10px',
                                                border:'2px solid black',
                                                color:'black',
                                                background:'lightgrey',
                                                fontSize:'20px'}}
                                        value = 'update image'/>
                            }
                            {updatingImage &&                             
                                <div style={{   padding:'10px',
                                                borderRadius:'10px',
                                                border:'2px solid black',
                                                color:'#000000',
                                                fontWeight:'900',
                                                background:'darkgrey',
                                                fontSize:'20px',
                                                cursor:'wait'}}>
                                                    <span className='flashing-text'>updating image</span>
                                </div>
                            }
                            {!updatingMenu &&                            
                                        <div onClick={clearWebsiteImageForm}
                                             style={{   display:'grid',
                                                        placeContent:'center',
                                                        cursor:'pointer',
                                                        borderRadius:'10px',
                                                        border:'2px solid black',
                                                        background:'rgb(255, 89, 118)',
                                                        fontWeight:'900',
                                                        color:'black',
                                                        padding:'10px 10px',
                                                        fontSize:'20px'
                                                    }}>
                                            cancel
                                        </div>
                            }
                        </div>                                                
                    </form>

                    <form   
                            action={updateLogoImage} 
                            id='logo-image'
                            className='specials-form'
                            style={{background:`#bf40bf`}}>

                        <h2 style={{textAlign:'center'}}>
                            {event.toLowerCase()}
                        </h2>
                        <h2 style={{textAlign:'center'}}>
                            logo image (paper menu)
                        </h2>
                        
                        <br/><br/>
                        
                        <input  type='hidden'
                                name='annual-event-name'
                                value='restaurant-week-fall-paper-logo'
                        />

                        <input  type='hidden' 
                                name='cloudinary_secure_URL' 
                                value={logoImageURL}
                                id='cloudinary_secure_URL' />

                        <input  type='hidden' 
                                value={logoImageID}
                                name='cloudinary_public_ID' 
                                id='cloudinary_public_ID' />
                        
                        <div style={{position:'relative',display:'inline-block'}}>
                            <div style={{
                                            position:'absolute',
                                            width:'100%',
                                            height:'100%',
                                            display:'grid',
                                            placeContent:'center',
                                            top:'0',
                                            left:'0'
                            }}>
                                <MdDoNotDisturbAlt size='150' id='do-not-circle3' style={{color:'transparent'}} />
                            </div>
                            <img src={logoImageURL ? logoImageURL : '/no-image.jpg' } style={{maxWidth:'100%'}} />
                        </div>
                        
                        <br/>
                        <div style={{textAlign:'center'}}>current image</div>
                        <br/><br/>
                        
                        <div id='file-input-logo-image'>
                            <label>
                                {logoImageURL ? <div>replace image (optional)</div> : <div>add image (optional)</div>}
                                <input  name='logo-image-file' 
                                        id='logo-image-file'
                                        onChange={handleLogoImageFileInputChange}
                                        type='file' />
                            </label>
                        </div>
                        <br/><br/>
                                                
                        {previewSource3 &&  <>
                                                <img src={previewSource3} style={{maxWidth:'300px',maxHeight:'300px'}} /><br/><br/>
                                            </>}

                        {logoImageURL &&                         
                                            <>                        
                                                <br/>
                                                <label style={{display:'flex',alignItems:'center'}}>
                                                    <input  type='checkbox' 
                                                            name='no-image'
                                                            checked={isNoLogoImageChecked}
                                                            onChange={toggleNoLogoImage}
                                                    /> 
                                                    <span>&nbsp;&nbsp;remove image / display NO image</span>
                                                </label>
                                                <br/>
                                            </>
                        }
                        
                        <br/><br/>
                        <div style={{display:'flex',justifyContent:'space-around'}}>
                            {!updatingImage2 &&                             
                                <input  type='submit' 
                                        style={{padding:'10px 10px',
                                                cursor:'pointer',
                                                borderRadius:'10px',
                                                border:'2px solid black',
                                                color:'black',
                                                background:'lightgrey',
                                                fontSize:'20px'}}
                                        value = 'update logo'/>
                            }
                            {updatingImage2 &&                             
                                <div style={{   padding:'10px',
                                                borderRadius:'10px',
                                                border:'2px solid black',
                                                color:'#000000',
                                                fontWeight:'900',
                                                background:'darkgrey',
                                                fontSize:'20px',
                                                cursor:'wait'}}>
                                                    <span className='flashing-text'>updating image</span>
                                </div>
                            }
                            {!updatingMenu &&                            
                                        <div onClick={clearLogoImageForm}
                                             style={{   display:'grid',
                                                        placeContent:'center',
                                                        cursor:'pointer',
                                                        borderRadius:'10px',
                                                        border:'2px solid black',
                                                        background:'rgb(255, 89, 118)',
                                                        fontWeight:'900',
                                                        color:'black',
                                                        padding:'10px 10px',
                                                        fontSize:'20px'
                                                    }}>
                                            cancel
                                        </div>
                            }
                        </div>

                                                
                    </form>

















                    <br/><br/><br/>











                        {allAnnualEventsMenuItems.filter(item=>(item.sequence == 0) && (item.event == event)).length != 0 &&
                            <>
                                <div className='specials-update-menu' style={{minHeight:'auto'}}>
                                    <div>
                                        <div className='specials-h1'>archives</div>
                                    </div>

                                    <br/><br/>

                                    {allAnnualEventsMenuItems.filter(item=>(item.sequence == 0) && (item.event == event)).map(data=>{
                                        return(
                                            <div key={data._id} className='special'>  
                                                <div>section: {data.section}</div>                                    
                                                <span className='name'>{data.name} </span>
                                                {data.allergiesAbbreviated && 
                                                    <span className='allergies-abbreviated'> ({data.allergiesAbbreviated})</span>}
                                                <span> {data.description}</span>
                                                <div className='allergies-complete'>{data.allergiesComplete}</div> 
                                                {data.cloudinary_secure_URL && <img src={data.cloudinary_secure_URL}
                                                                                style={{maxWidth:'100px',maxHeight:'100px'}}    
                                                                            />}                                            

                                                <div style={{marginTop:'5px'}}>
                                                    <span   className='btn unarchive-btn'
                                                            onClick={()=>unarchiveItem(data._id)}>
                                                        UNarchive</span>
                                                    <span   className='btn delete-btn'
                                                            onClick={()=>deleteAnnualEventsMenuItem(data._id)}>DELETE</span>
                                                    <br/><br/><br/>
                                                </div>
                                            </div>
                                        )
                                    })}


                                </div>

                            
                            </>}



            </div>{/* .manager-page-wrapper */}
        </>
    )
}